<template>
    <Transfer
        class="measure-transfer"
        :data-source="adaptedMeasures"
        :target-keys="targetKeys"
        show-search
        :render="({ title }) => title"
        :filter-option="filter"
        @change="handleChange"
    />
</template>

<script>
import { Transfer } from 'ant-design-vue';
export default {
    components:{
        Transfer,
    },
    props: {
        measures: {
            type: Array,
            default: () => [],
        },
        access: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        targetKeys: [],
    }),
    computed: {
        adaptedMeasures() {
            return this.measures.map(({ id, name }) => ({ key: id, title: name }));
        },
    },
    watch: {
        access: {
            immediate: true,
            handler() {
                this.targetKeys = this.access;
            },
        },
    },
    methods: {
        handleChange(targetKeys, direction, moveKeys) {
            this.targetKeys = targetKeys;
            this.$emit('on-change', targetKeys);
        },
        filter(value, { title }) {
            return title.toLowerCase().includes(value.toLowerCase());
        },
    },
};
</script>

<style lang="scss">
.measure-transfer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ant-transfer-list {
        width: 45%;
        height: calc(100vh - 103px);
    }
}

</style>